import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import async from './async';
import './index.css';
import './assets/iconfont/iconfont.css';
import Bookstore from './pages/bookstore/bookstore';

import version from './version.json';
console.log(`liuhui ${version.VERSION}`);

let ShudanDetails = async(() => import('./pages/shudanDetails/shudanDetails'));
let BookListDetails = async(() => import('./pages/bookListDetails/bookListDetails'));
let SubjectDetails = async(() => import('./pages/subjectDetails/subjectDetails'));
let Classify = async(() => import('./pages/classify/classify'));
let Search = async(() => import('./pages/search/search'));
let SearchResult = async(() => import('./pages/searchResult/searchResult'));
let SubjectList = async(() => import('./pages/subjectList/subjectList'));
let MonthlyZone = async(() => import('./pages/monthlyZone/monthlyZone'));
let Catalogue = async(() => import('./pages/catalogue/catalogue'));
let LabelDetails = async(() => import('./pages/labelDetails/labelDetails'));
let BookDetails = async(() => import('./pages/bookDetails/bookDetails'));
let WorkDetails = async(() => import('./pages/workDetails/workDetails'));
let Booklist = async(() => import('./pages/booklist/booklist'));

// let InputDemo = async(() => import("./InputDemo"));
// import { Route, Router } from "react-router";
// import { Router, Route, H } from 'react-router';
// import * as serviceWorker from './serviceWorker';
ReactDOM.render(
  <BrowserRouter basename="/bookstore_touch">
    <Switch>
      <Route exact path="/" component={Bookstore} />
      <Route path="/index.html" component={Bookstore} />
      <Route path="/search" component={Search} />
      <Route path="/booklist" component={Booklist} />
      <Route path="/bookstore" component={Bookstore} />
      <Route path="/subjectList" component={SubjectList} />
      <Route path="/monthlyZone" component={MonthlyZone} />
      <Route path="/classify" component={Classify} />
      <Route path="/catalogue" component={Catalogue} />
      <Route path="/workDetails" component={WorkDetails} />
      <Route path="/bookDetails" component={BookDetails} />
      <Route path="/shudanDetails" component={ShudanDetails} />
      <Route path="/subjectDetails" component={SubjectDetails} />
      <Route path="/labelDetails" component={LabelDetails} />
      <Route path="/bookListDetails" component={BookListDetails} />
      <Route path="/searchResult" component={SearchResult} />
      {/* both /roster and /roster/:number begin with /roster */}
      {/* <Route path="/demo" component={async(() => import('./App'))} /> */}
      {/* <Route path='/lifeboat' component={async(() => import("./game/lifeboat/app"))} />
      <Route path='/profile' component={Profile} />
      <Route path='/pintu' component={PinTu} />
      <Route path='/avalon_played' component={Avalon_played} />
      <Route path='/avalon' component={Avalon} />
      <Route path='/avalon2' component={async(() => import("./game/avalon2/app"))} /> */}
      {/* <Route path='/schedule' component={Schedule}/> */}
    </Switch>
  </BrowserRouter>,

  //     {/* <IndexRoute component={App}/> */}
  //     {/* <Route path="about" component={About} />
  //     <Route path="inbox" component={Inbox}>
  //       <Route path="messages/:id" component={Message} />
  //     </Route> */}
  // </BrowserRouter>
  document.getElementById('root')
);

// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
